export default __webpack_public_path__ + "static/what-we-do-2-1-298580b8c49d06375c63237557167dfb.jpg";